import { useQuery } from '@tanstack/react-query';
import { api } from '../lib_api';

export default function AiUsage() {
  const usage = useQuery({ queryKey: ['admin', 'ai', 'usage'], queryFn: async () => (await api.get('/api/ai/admin/usage')).data });

  return (
    <section className="space-y-4">
      <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-darkCard dark:bg-darkCard/60">
        <h3 className="text-sm font-semibold">AI Cost & Usage (7d)</h3>
        <p className="text-xs text-mutedGray">Requests, blocked calls, cache efficiency, and estimated cost drivers.</p>
      </div>
      <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white dark:border-darkCard dark:bg-darkCard/60">
        <table className="min-w-full text-sm">
          <thead><tr><th>Feature</th><th>Events</th><th>Blocked</th><th>Cached</th><th>Avg Latency</th><th>Cost (USD)</th></tr></thead>
          <tbody>
            {(usage.data?.summary || []).map((row: any) => (
              <tr key={row.feature_key}><td>{row.feature_key}</td><td>{row.events}</td><td>{row.blocked}</td><td>{row.cached}</td><td>{row.avg_latency_ms}</td><td>{row.cost_usd}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
